import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class EFSAccountGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var efsaccountsGrid = this;
		setTimeout(function(){
			efsaccountsGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var efsaccountsGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_TCH_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_TCH_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_TCH_ACCOUNTS:UPDATE_STATUS'],
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'tchCarrierId',
					header: 'Carrier Id',					
					width: '7em'
				},
				{						
					path: 'contractNo',
					header: 'Contract No',					
					width: '7em'
				},				
				{						
					path: 'tchAccountTypeDescription',
					header: 'Account Type',					
					width: '7em'					
				},
				{						
					path: 'companyName',
					header: 'Company Name',						
					'flex-grow': '1'
				},
				{						
					path: 'accountName',
					header: 'Account Name',					
					width: '9em',
					renderer: function(root, column, rowData) {										
						if (rowData.item.accountName) {
							root.innerHTML = rowData.item.nameOnAccount + ' (' + rowData.item.accountName + ')';				
						} else {
							root.innerHTML = rowData.item.nameOnAccount;
						}
					}
				},
				{						
					path: 'payThisAcctFlag',
					header: 'Pay Flag',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'autoPayFlag',
					header: 'Auto Pay Flag',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'autoBillFlag',
					header: 'Auto Bill Flag',					
					'text-align': 'center',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					efsaccountsGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						efsaccountsGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getTchAccountService().getTCHAccounts(efsaccountsGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'tch-accounts',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'tch-accounts.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		efsaccountsGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit EFS Account',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-number-field',
											label: 'Carrier Id',
											name: 'tchCarrierId',
											required: true,
											min: 0,
											max: 9999999999
										},
										{
											tag: 'vaadin-number-field',
											label: 'Contract No',
											name: 'contractNo',
											required: true,
											min: -1,
											max: 999999999
										},
										{
											tag: 'vaadin-text-field',
											label: 'Name on Account',
											name: 'nameOnAccount',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Card No',
											name: 'cardNo',
											maxlength: 80
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Account Type', 
											name: 'tchAccountType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('TchAccountType').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Company', 
											name: 'companyId',
											'item-value-path': 'companyId',
											'item-label-path': 'companyName',
											postinit: function(combo) {
												Service.getCompanyService().loadCompanies().then(function(data){
													combo.items = data.data;
													combo.required = true;
												});
											}	
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'payThisAcctFlag',
											colspan: 2,
											label: 'Pay This Account'										
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'autoPayFlag',
											colspan: 2,
											label: 'Auto Pay'										
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'autoBillFlag',
											colspan: 2,
											label: 'Auto Bill'										
										},
										{
											tag: 'hr',
											colspan: 2
										},										
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 1',
											name: 'addressLine1',	
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 2',
											name: 'addressLine2',											
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Address Line 3',
											name: 'addressLine3',											
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'City',
											name: 'cityName',
											required: true,
											maxlength: 120
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'state',
											label: 'State/Providence', 
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-text-field',
											label: 'Postal Code',
											name: 'postalCode',											
											required: true,
											maxlength: 40
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																	var stateCB = ElementUtil.query(formPanel, 'state');																	
																	if (stateCB.selectedItem) {
																		data.countryCode = stateCB.selectedItem.country;
																	} else {
																		delete data.stateProvCode;
																	}
																	if (!data.payThisAcctFlag) {
																		data.payThisAcctFlag = false;
																	}
																	if (!data.autoPayFlag) {
																		data.autoPayFlag = false;
																	}
																	if (!data.autoBillFlag) {
																		data.autoBillFlag = false;
																	}
																	if (record) {
																		data.tchAccountId = record.tchAccountId;
																	}
																	return data;
																},
																actualCall: function(data) {
																	return BillingService.getTchAccountService().saveTCHAccount(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved EFS Account', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							formPanel.load(record);							
						}
						
					}
				}
			});
		
						
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				BillingService.getTchAccountService().updateTCHAccountStatus(record.tchAccountId, false).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				BillingService.getTchAccountService().updateTCHAccountStatus(record.tchAccountId, true).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}
		};	

	}
	
};
customElements.define('dl-efsaccounts-grid', EFSAccountGrid);
